export function mergeFilesToDataTransferFileList(
  existing: FileList | File[] | null | undefined,
  newFiles: File[]
): FileList {
  const dt = new DataTransfer();
  const prior = existing ? Array.from(existing as ArrayLike<File>) : [];
  for (const f of prior) {
    dt.items.add(f);
  }
  for (const f of newFiles) {
    dt.items.add(f);
  }
  return dt.files;
}

export function removeFileAtIndexFromFileList(
  existing: FileList | File[] | null | undefined,
  index: number
): FileList | undefined {
  if (existing == null) {
    return undefined;
  }
  const prior = Array.from(existing as ArrayLike<File>);
  if (index < 0 || index >= prior.length) {
    const unchanged = new DataTransfer();
    for (const f of prior) {
      unchanged.items.add(f);
    }
    return unchanged.files;
  }
  const next = prior.filter((_, i) => i !== index);
  if (next.length === 0) {
    return undefined;
  }
  const dt = new DataTransfer();
  for (const f of next) {
    dt.items.add(f);
  }
  return dt.files;
}
